<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="['/office/new-certification/detail', certification?.id]"
                      [queryParams]="{ tab: 'domains' }">chevron_left</mat-icon>
            <h1 class="page-title">View Certification Domain</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item " [routerLink]="['/office/new-certification/detail', certification?.id]"
                  [queryParams]="{ tab: 'domains' }">{{certification?.certificationTitle}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">View Certification Domain</span>
        </div>
    </div>

    <hr class="mb-4" />

    <div class="row">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Certification Title</h4>
            <div class="label-text">{{certification?.certificationTitle}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Association Name</h4>
            <div class="label-text">{{associationName}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Domain Name</h4>
            <div class="label-text">{{domain?.domainName}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Target Objectives</h4>
            <div class="card-bg-20 rounded-2 p-3 mt-3 mb-5">
                <div class="label-text">
                    <ul>
                        <li class="mb-2" *ngFor="let obj of domain?.objectives; let i = index">
                            <div>{{obj?.objectiveName}}</div>
                            <blockquote class="mt-3 text-color-black-normal-50" [innerHTML]="obj?.term | keepHtml"></blockquote>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
    <div class="row my-4">
        <div class="col-12">
            <button class="edit-button" (click)="goEdit(certification?.id, domain?.id)" mat-raised-button >
                <mat-icon>edit</mat-icon>
                Edit
            </button>
        </div>
    </div>
</div>
